import IframeBox from '@/components/iframe_box_ml/IframeBox';

const dgm = () => {
  return <IframeBox src="/decisionGraphManage/DGM"></IframeBox>;
};

export default dgm;
